export const LOADER_SIZE = 80;
